import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, Users2, Image, MessageSquare, Inbox, Activity as ActIcon, ExternalLink } from "lucide-react";
import api from "@/lib/api";

export default function Overview() {
  const [stats, setStats] = useState(null);
  const [subs, setSubs] = useState([]);
  const [acts, setActs] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/admin/list/courses"),
      api.get("/admin/list/faculty"),
      api.get("/admin/list/gallery"),
      api.get("/admin/list/events"),
      api.get("/admin/submissions"),
      api.get("/admin/activity"),
    ]).then(([c, f, g, e, s, a]) => {
      setStats({ courses: c.data.length, faculty: f.data.length, gallery: g.data.length, events: e.data.length, subs: s.data.length });
      setSubs(s.data.slice(0, 5));
      setActs(a.data.slice(0, 6));
    });
  }, []);

  const cards = [
    { label: "পাঠক্রম", value: stats?.courses, icon: BookOpen, to: "/admin/courses" },
    { label: "শিক্ষক", value: stats?.faculty, icon: Users2, to: "/admin/faculty" },
    { label: "গ্যালারি", value: stats?.gallery, icon: Image, to: "/admin/gallery" },
    { label: "অনুষ্ঠান", value: stats?.events, icon: MessageSquare, to: "/admin/events" },
    { label: "ফর্ম জমা", value: stats?.subs, icon: Inbox, to: "/admin/submissions" },
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-heading text-2xl font-bold text-stone-800">স্বাগতম 👋</h1>
          <p className="text-sm text-stone-500 mt-1">আপনার ওয়েবসাইটের সারসংক্ষেপ</p>
        </div>
        <a href="/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 rounded-full bg-[var(--c-primary)] text-white px-4 py-2 text-sm hover:bg-[var(--c-secondary)] transition-colors">
          <ExternalLink className="h-4 w-4" /> ওয়েবসাইট দেখুন
        </a>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} className="bg-white rounded-2xl border border-stone-200 p-5 hover:border-[var(--c-accent)] transition-colors">
            <c.icon className="h-6 w-6 text-[var(--c-secondary)]" strokeWidth={1.5} />
            <div className="font-heading text-3xl font-bold text-stone-800 mt-3">{c.value ?? "—"}</div>
            <div className="text-sm text-stone-500 mt-1">{c.label}</div>
          </Link>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6 mt-6">
        <div className="bg-white rounded-2xl border border-stone-200 p-6">
          <h2 className="font-heading text-lg font-semibold text-stone-800 flex items-center gap-2"><Inbox className="h-5 w-5 text-[var(--c-secondary)]" /> সাম্প্রতিক ফর্ম</h2>
          <div className="mt-4 space-y-3">
            {subs.length === 0 && <p className="text-sm text-stone-400">কোনো জমা নেই।</p>}
            {subs.map((s) => (
              <div key={s.id} className="flex items-center justify-between border-b border-stone-100 pb-3 last:border-0">
                <div>
                  <div className="text-sm font-medium text-stone-700">{s.data?.name || "—"}</div>
                  <div className="text-xs text-stone-400">{s.type === "admission" ? "ভর্তি" : "যোগাযোগ"} · {s.data?.phone || s.data?.email}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-stone-200 p-6">
          <h2 className="font-heading text-lg font-semibold text-stone-800 flex items-center gap-2"><ActIcon className="h-5 w-5 text-[var(--c-secondary)]" /> কার্যকলাপ</h2>
          <div className="mt-4 space-y-3">
            {acts.map((a) => (
              <div key={a.id} className="text-sm text-stone-600 border-b border-stone-100 pb-2 last:border-0">
                <span className="font-medium">{a.action}</span> — <span className="text-stone-400">{a.target}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
